
import { ReloadHistoryDataTable } from "@/components/ReloadHistoryDataTable";

export default function DashboardPage() {
  return (
    <div>
      <div className="w-full flex items-center justify-center mb-6 gap-4">
        <a href="/parrainage">
          <button className="bg-blue-600 text-white font-bold py-2 px-4 rounded shadow hover:bg-blue-700">
            Parrainer un utilisateur et voir vos filleuls
          </button>
        </a>
      </div>
      <ReloadHistoryDataTable />
    </div>
  );
}




